import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles(() =>
  createStyles({
    dropdown: {
      marginTop: 10,
      marginLeft: -5,
      width: 691,
      background: '#E2E8F0',
      borderRadius: 5,
      padding: '10px 2px',
      maxHeight: 246,
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: 3,
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#1A0063',
      },
      '&::-webkit-scrollbar-track': {
        width: 3,
      },
      '&::-webkit-scrollbar-thumb:hover': {
        width: 10,
      },
      '& [role="progressbar"]': {
        left: 'calc(50% - 20px)',
      },
    },
    dropdown_inner: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      width: '100%',
      '& > div': {
        width: '100%',
        padding: '10px 8px',
        minHeight: 39,
        '&:not(:last-child)': {
          borderBottom: '1px solid #FFFFFF',
        },
      },
    },
    row: {
      position: 'relative',
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 20,
      width: '100%',
      fontSize: 12,
    },
    add_button: {
      background: 'transparent',
      borderRadius: '50%',
      width: 15,
      minWidth: 15,
      height: 15,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid #000',
      cursor: 'pointer',
      '&:hover': {
        opacity: 0.5,
      },
    },
    center: {
      textAlign: 'center',
      margin: 'auto',
    },
  })
)
export default useStyles
